/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RootPathSelectorComponent } from './root-path-selector.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [RootPathSelectorComponent],
  imports: [CommonModule, FormsModule],
  exports: [RootPathSelectorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RootPathSelectorModule {}
